import script from "./IconSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./IconSelect.vue?vue&type=script&setup=true&lang=js"

import "./IconSelect.vue?vue&type=style&index=0&id=75c2c6f4&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c2c6f4"]])

export default __exports__